import { createFileRoute } from "@tanstack/react-router"
import { DashboardPage } from "@/app"

export const Route = createFileRoute("/(user)/t/$tenantSlug/dashboard")({
  component: RouteComponent,
})

function RouteComponent() {
  return <DashboardPage />
}
